module.exports = __webpack_public_path__ + "img/kraken-market-chart.185b7e1a.webp";